import React, { useState } from 'react';
import { Truck, Clock } from 'lucide-react';
import TrustBadge from './TrustBadge';

const DispatcherView = ({ data, save, user, addNotification, updateAnalytics }) => {
  const [sel, setSel] = useState(null);
  const [form, setForm] = useState({});

  const approve = () => {
    if (!form.trans || !form.driver || !form.vehicle || !form.exp) {
      alert('All fields required');
      return;
    }
    const updated = {
      ...sel,
      status: 'approved',
      transporter: form.trans,
      driver: form.driver,
      vehicle: form.vehicle,
      expectedDelivery: form.exp,
      approvedBy: user.name,
      approvedAt: new Date().toISOString(),
      custody: 'transporter'
    };
    const updatedDispatches = data.dispatches.map(d => d.id === sel.id ? updated : d);
    save('dispatches', updatedDispatches);
    updateAnalytics(updatedDispatches);
    addNotification('Dispatch Approved', `${sel.productName} assigned to ${form.driver}`, 'info');
    alert('✅ Approved');
    setSel(null);
    setForm({});
  };

  const pending = data.dispatches.filter(d => d.status === 'pending_approval');

  if (sel) {
    return (
      <div className="space-y-4">
        <h2 className="text-2xl font-bold">Approve Dispatch</h2>
        <div className="bg-purple-50 border border-purple-200 p-4 rounded-lg">
          <p className="font-bold text-lg">{sel.productName}</p>
          <p className="text-sm text-gray-600">Qty: {sel.quantity} • By: {sel.preparedBy}</p>
        </div>
        <div className="grid grid-cols-2 gap-3 bg-green-50 p-3 rounded-lg border border-green-200">
          <div className="text-center">
            <p className="text-xs text-gray-500">Packed ✓</p>
            <p className="text-green-600 font-semibold text-sm mt-1">Photo verified</p>
          </div>
          <div className="text-center">
            <p className="text-xs text-gray-500">Sealed ✓</p>
            <p className="text-green-600 font-semibold text-sm mt-1">Photo verified</p>
          </div>
        </div>
        <input
          type="text"
          placeholder="Transporter company *"
          className="w-full p-3 border-2 rounded-lg"
          value={form.trans || ''}
          onChange={e => setForm({...form, trans: e.target.value})}
        />
        <input
          type="text"
          placeholder="Driver name *"
          className="w-full p-3 border-2 rounded-lg"
          value={form.driver || ''}
          onChange={e => setForm({...form, driver: e.target.value})}
        />
        <input
          type="text"
          placeholder="Vehicle ID *"
          className="w-full p-3 border-2 rounded-lg"
          value={form.vehicle || ''}
          onChange={e => setForm({...form, vehicle: e.target.value})}
        />
        <div>
          <p className="text-sm font-semibold mb-1">Expected Delivery *</p>
          <input
            type="datetime-local"
            className="w-full p-3 border-2 rounded-lg"
            value={form.exp || ''}
            onChange={e => setForm({...form, exp: e.target.value})}
          />
        </div>
        <div className="flex gap-3">
          <button onClick={() => { setSel(null); setForm({}); }} className="flex-1 bg-gray-200 p-3 rounded-lg font-semibold">Cancel</button>
          <button onClick={approve} className="flex-1 bg-green-600 text-white p-3 rounded-lg font-bold">Approve</button>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-2xl font-bold">Dispatcher</h2>
        <TrustBadge score={user.trustScore} />
      </div>
      <div className="bg-yellow-50 border border-yellow-200 p-3 rounded-lg flex items-center gap-2">
        <Clock className="w-5 h-5 text-yellow-600" />
        <p className="text-sm font-semibold">{pending.length} awaiting approval</p>
      </div>
      {pending.length === 0 ? (
        <div className="text-center py-12">
          <Truck className="w-16 h-16 text-gray-300 mx-auto mb-3" />
          <p className="text-gray-500">No pending dispatches</p>
        </div>
      ) : (
        pending.map(d => (
          <div
            key={d.id}
            onClick={() => setSel(d)}
            className="border-2 p-4 rounded-lg cursor-pointer hover:border-purple-500 hover:bg-purple-50 transition-all"
          >
            <div className="flex justify-between items-start">
              <div>
                <p className="font-bold">{d.productName}</p>
                <p className="text-sm text-gray-600">Qty: {d.quantity} • By: {d.preparedBy}</p>
                <p className="text-xs text-gray-400 mt-1">{new Date(d.preparedAt).toLocaleString()}</p>
              </div>
              <span className="bg-yellow-100 text-yellow-700 text-xs px-2 py-1 rounded-full font-semibold">Pending</span>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default DispatcherView;
